/***
*
*   CAMPAIGN
*   Information for user to get help and support
*
**********/

import React, { Fragment, useState, useContext, useEffect } from 'react';
import { ProgressSteps, Checkbox, Grid, Icon, AuthContext, useAPI, Loader } from 'components/lib';
import Style from './creation-campaign.module.scss';
import axios from 'axios'; 

// if (window.performance) {
//   if (performance.navigation.type == 1) {
//     window.location.href = window.location.origin + '/campaign';
//   }
// }


export function CampaignTemplates(props){
  const authContext = useContext(AuthContext);
  const [templates, setTemplates] = useState({ data: null, error: '' });
  useEffect(() => {
    let active = true;
    axios.get('/api/templates').then(res => {
      if (active) setTemplates({ data: res.data.data, error: '' });
    }).catch(() => {
      if (active) setTemplates({ data: [], error: 'No se pudieron cargar las plantillas. Actualiza la página e inténtalo de nuevo.' });
    });
    return () => { active = false; };
  }, []);

  const [templateNames, setTemplateNames] = useState([]);
  const [selectThemesScreen, setSelectThemesScreen] = useState([]);

  const selectTheme = (value) => {
    let auxNames = templateNames;
    let auxSelected = selectThemesScreen;

    let filterValue = auxNames.filter(val => val === value.key);
    let themeHTMLValue = templates.data.filter(val => val.key === value.key);

    if(filterValue.length === 0) {
      auxNames = [...auxNames, value.key];
      setTemplateNames(auxNames);
      if(themeHTMLValue.length > 0) {
        auxSelected = [...auxSelected, themeHTMLValue[0]];
        setSelectThemesScreen(auxSelected);
      }
    } else {
      let diselect = auxNames.filter(val => val !== value.key);
      setTemplateNames(diselect);
      let diselectScreen = auxSelected.filter(val => val.key !== value.key);
      setSelectThemesScreen(diselectScreen);
    }
  }

  return (
    <Fragment>
      <div style={{ marginTop: '-40px' }}>
        <ProgressSteps items={[
            { name: 'Crear', url: '/creation', completed: true },
            { name: 'Audiencia', url: '/camp-audience', completed: true },
            { name: 'Plantillas', url: '/theme', completed: true },
            { name: 'Resumen', url: '/summary', completed: false },
            { name: 'Listo', url: '/finish', completed: false },
        ]} marginRight='-15px' shadow/>
      </div>

      {templates.data ?
        <div style={{marginTop: '3em'}}>
          {templates.error && <p role='alert'>{templates.error}</p>}
          {!templates.error && templates.data.length === 0 && <p>No hay plantillas guardadas. <a href='/templates'>Sube una plantilla en Plantillas</a> para continuar.</p>}
          <Grid cols='2'>

            <div style={{ minWidth: 840 }} className='content-html'>
              {selectThemesScreen && selectThemesScreen.length > 0 ?
                selectThemesScreen.map((val, i) => {
                  return <iframe title={val.name || 'Vista previa de plantilla'} sandbox='' srcDoc={val.obj} key={val.key} style={{width: '100%', height: 500, border: '1px solid #ddd'}} />
                }) :
                <Icon image='image' size={391} color='blue' className={ Style.centericon }/>
              }
            </div>

            <div style={{ maxWidth: 350 }}>
              {templates.data.map((val, i) => {
                return (
                  <div 
                    style={{
                      maxWidth: '300px', 
                      maxHeight: '300px', 
                      marginBottom: '20px',
                      position: 'relative'
                    }} 
                    key={i}
                  >
                    <p>{val.name}</p>
                    {val.preview ? <img alt={val.name} src={val.preview} /> : <iframe title={`Vista previa ${val.name}`} sandbox='' srcDoc={val.obj} style={{width: '100%', height: 180, border: '1px solid #ddd', pointerEvents: 'none'}} />} 
                    <Checkbox 
                      embedded 
                      callback={ e => selectTheme(val) } 
                      checked={ templateNames.filter(name => name === val.key).length > 0 ? true : false}
                    />
                  </div>
                )
              })}
            </div>

          </Grid> 

          <div style={{ position: 'fixed', bottom: '2em', right: '2em' }}>
            <ProgressSteps items={[
              { name: 'Regresar', url: '/camp-audience', completed: false, iconLeft: 'chevron-left' },
              { name: 'Continuar', url: '/summary', completed: true, iconRight: 'chevron-right', locked: selectThemesScreen.length === 0 ? true : false, click: () => authContext.dispatch({ type: 'ADD_CAMPAIGN', value: { selectThemesScreen } }) },
            ]} marginRight='10px'/>
          </div>
        </div> :
        <Loader/>
      }
    </Fragment>
  )
}